module.exports = __webpack_public_path__ + "static/media/icn_end_date.6a7ef39d.svg";